// extracted by mini-css-extract-plugin
module.exports = {"header-search-bar-suggestions-container":"header-search-bar-suggestions-container_header-search-bar-suggestions-container__L8bKi"};